import SearchForm from './SearchForm';

export type { SearchFormProps } from './SearchForm';
export default SearchForm;
